<template>
  <div class="bg-orange-academy-150 p-6 rounded">
    <section>
      <div :class="isLoading ? 'pt-6' : ''">
        <Skeleton :loading="isLoading" lineHeight="2"/>
      </div>
      <div class="mt-3 flex flex-col">
        <div
          v-for="method in paymentMethods" :key="method.id"
          class="py-3 h-16 flex justify-around items-center
           bg-white mb-8 rounded-lg px-4">
          <input type="radio" :value="method.id" v-model="selectedPaymentMethod"
          role="checkbox" v-if="radioButtons">
          <card :card="method" @deleted="getPaymentMethods()" />
        </div>
        <button class="my-3 shadow-md rounded-md hover:bg-gray-700 hover:text-white
        text-sm lg:text-xl font-black bg-white w-1/2 md:w-1/3 mx-auto p-2"
          @click="addNewPaymentMethod()" v-if="!notShowAddButton && !isLoading">
            {{$t('stripe.add')}}
        </button>
      </div>
    </section>
    <div v-if="addNewCard">
      <button class="flex justify-end w-full text-white"
        @click="addNewCard=false" title="delete" >
          <close-icon />
      </button>
      <stripe-component
        @updated-payment-method="rechargePaymentMethods()" />
    </div>
  </div>
</template>

<script>
import StripeComponent from '@/components/payment/Stripe.vue';
import Card from '@/components/payment/Card.vue';
import { mapGetters } from 'vuex';
import { Skeleton } from '@/components/Skeleton/src/index';
import { getStudentPaymentMethods } from '@/services/StudentService';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  props: ['radioButtons', 'notShowAddButton', 'value', 'add'],

  data() {
    return {
      startAdding: !!this.add,
      addNewCard: false,
      paymentMethods: [],

      selectedPaymentMethod: this.value,

      idToDelete: '',

      isLoading: false,
    };
  },

  components: {
    StripeComponent,
    Card,
    CloseIcon,
    Skeleton,
  },

  watch: {
    deletedPaymentMethod() {
      this.getPaymentMethods();
    },

    selectedPaymentMethod() {
      this.$emit('input', this.selectedPaymentMethod);
    },
  },

  computed: {
    ...mapGetters({
      student: ['auth/student'],
      deletedPaymentMethod: ['auth/deletedPaymentMethod'],
    }),
  },

  mounted() {
    if (this.student) {
      this.getPaymentMethods();
    }
  },

  methods: {
    getPaymentMethods() {
      this.isLoading = true;
      this.paymentMethods = [];
      getStudentPaymentMethods(this.student.id, 'Cards').then((response) => {
        this.paymentMethods = response.data;
        this.isLoading = false;
        this.selectedPaymentMethod = this.paymentMethods.length > 0
          ? this.paymentMethods[0].id : null;
        if (this.addNewCard) {
          this.addNewCard = false;
        }
        if (this.startAdding) {
          this.addNewPaymentMethod();
          this.startAdding = false;
        }
      }).catch((error) => {
        this.isLoading = false;
        this.console.log(error);
      });
    },

    addNewPaymentMethod() {
      this.addNewCard = true;
    },

    rechargePaymentMethods() {
      this.getPaymentMethods();
    },

    setLoadingClass(id) {
      if (this.isLoading && this.idToDelete === id) return 'loader';
      return '';
    },

  },
};
</script>
